export const LOADER = "UPDATE_LOADER";
export const UPDATE_TOKEN  = "UPDATE_TOKEN";
export const UPDATE_TRACK_TYPE = "UPDATE_TRACK_TYPE"
export const CITY_LIST = "UPDATE_CITY_LIST";
export const FROM_CITY = "UPDATE_FROM_CITY";
export const TO_CITY = "UPDATE_TO_CITY";

export const TRIP_FROM_CITY = "UPDATE_TRIP_FROM_CITY";
export const TRIP_TO_CITY = "UPDATE_TRIP_TO_CITY";


export const STOPAGE_FROM_CITY = "UPDATE_STOPAGE_FROM_CITY";
export const STOPAGE_TO_CITY = "UPDATE_STOPAGE_TO_CITY";
export const UPDATE_STOPAGE_SERVICE = "UPDATE_STOPAGE_SERVICE";
export const UPDATE_STOPAGE_TRIPID = "UPDATE_STOPAGE_TRIPID";

export const DROP = "UPDATE_DROP";
export const ROUTE_FROM = "UPDATE_ROUTE_FROM";
export const ROUTE_TO = "UPDATE_ROUTE_TO";
export const ROUTE_STATUS = "UPDATE_ROUTE_STATUS";

export const TYPE_WISE = "UPDATE_TYPE_WISE";
export const MASTER_BUS_NO = "UPDATE_MASTER_BUS_NO";

export const TRIP_FROM = "UPDATE_TRIP_FROM";
export const TRIP_TO = "UPDATE_TRIP_TO";
export const TRIP_SERVICE = "UPDATE_TRIP_SERVICE";

export const SET_DEP_DATE = "SET_DEP_DATE";
export const SET_TO_DATE = "SET_TO_DATE";

export const UPDATE_MASTERBUS_DETAILS = "UPDATE_MASTERBUS_DETAILS";
export const UPDATE_SERVICENAME_DETAILS = "UPDATE_SERVICENAME_DETAILS";
export const UPDATE_TRIPSERVICE_TIME = "UPDATE_TRIPSERVICE_TIME";
export const UPDATE_SERVICENAME_DET = "UPDATE_SERVICENAME_DET";
export const UPDATE_TRIP_TIME  = "UPDATE_TRIP_TIME";

export const UPDATE_ROUTE_DETAILS = "UPDATE_ROUTE_DETAILS";
export const UPDATE_STATIC_DETAILS = "UPDATE_STATIC_DETAILS";

export const UPDATE_TAB = "UPDATE_TAB";
export const UPDATE_TRIPMAP = "UPDATE_TRIPMAP";
export const UPDATE_ID = "UPDATE_ID";
export const UPDATE_GPS_ID = "UPDATE_GPS_ID";
export const UPDATE_MAP_KEY = "UPDATE_MAP_KEY";
export const UPDATE_LAT_LNG = "UPDATE_LAT_LNG";
export const UPDATE_BUS_ID = "UPDATE_BUS_ID";
export const UPDATE_ENTRY_TIME = "UPDATE_ENTRY_TIME";

export const UPDATE_HEAD_TEXT = "UPDATE_HEAD_TEXT";
export const UPDATE_MESSAGE_TEXT = "UPDATE_MESSAGE_TEXT";
export const UPDATE_FILTER_MESSAGE = "UPDATE_FILTER_MESSAGE";
export const UPDATE_OTHER_DETAILS = "UPDATE_OTHER_DETAILS";
export const UPDATE_LINEGRAPH_DETAILS = "UPDATE_LINEGRAPH_DETAILS";

//FILTER 

export const UPDATE_FILTER_SERVICENAME = "UPDATE_FILTER_SERVICENAME";
export const UPDATE_FILTER_STATUS = "UPDATE_FILTER_STATUS";
export const UPDATE_FILTER_TRIP = "UPDATE_FILTER_TRIP";
export const UPDATE_FILTER_MASTERBUS = "UPDATE_FILTER_MASTERBUS";


export const SELECTED_FILTER_SERVICENAME = "SELECTED_FILTER_SERVICENAME";
export const SELECTED_FILTER_STATUS = "SELECTED_FILTER_STATUS";
export const SELECTED_FILTER_TRIPID = "SELECTED_FILTER_TRIPID";
export const SELECTED_FILTER_MBUSNO = "SELECTED_FILTER_MBUSNO";

export const UPDATE_FILTER_DETAILS = "UPDATE_FILTER_DETAILS";


export const ROUTE_FROM_CHART_DATE = "ROUTE_FROM_CHART_DATE";
export const ROUTE_TO_CHART_DATE = "ROUTE_TO_CHART_DATE";

export const TRIP_FROM_CHART_DATE = "TRIP_FROM_CHART_DATE";
export const TRIP_TO_CHART_DATE = "TRIP_TO_CHART_DATE";

export const BUS_FROM_CHART_DATE = "BUS_FROM_CHART_DATE";
export const BUS_TO_CHART_DATE = "BUS_TO_CHART_DATE";

export const STOPAGE_FROM_CHART_DATE = "STOPAGE_FROM_CHART_DATE";
export const STOP_TO_CHART_DATE = "STOPAGE_TO_CHART_DATE";
export const SET_DATE_ARR = "SET_DATE_ARR";
export const UPDATE_DEFAULT_SERVICE = "UPDATE_DEFAULT_SERVICE"
export const UPDATE_BUSMAP_DETAILS = "UPDATE_BUSMAP_DETAILS";

export const UPDATE_CARD_STATUS  = "UPDATE_CARD_STATUS";
export const UPDATE_MAP_LOADER   = "UPDATE_MAP_LOADER";




